import React, { useEffect , useState} from "react";
import AnimeList from "./AnimeCard";
import AnimePopular from "./komponen/AnimePopular";
import { Route,Routes } from "react-router-dom";
import CharacterList from "./komponen/CharacterList";
import RecommendCard from "./komponen/RecommendCard";
import ViewBody from "./komponen/View";

const HomeBody = (props) =>{

    const [popularResult,setPopular] = useState([]);
    const [recomResult,setRecom] = useState([]);

    const recom = async () => {
        const response = await fetch('https://api.jikan.moe/v4/recommendations/anime?page=' + Math.floor(Math.random() * 4));
        const res = await response.json();

        setRecom(res.data);
        // console.log(res.data);
    }
    const Popular = async () =>{
        const response = await fetch('https://api.jikan.moe/v4/top/anime?filter=bypopularity&limit=4');
        const res = await response.json();
        // console.log(res.data);
        setPopular(res.data);
      }
    // console.log(props);
    useEffect(() => {
        // if(props.rute == 'recom'){
            recom();
        // }else if(props.rute == 'home'){
            Popular();
        // }
    }, [])


    return(
        <div className="col-span-4 p-5">
            <nav className="bg-[#1E1F25] h-32 rounded-2xl  border-[rgb(48,54,68)] border-[0.00625rem] flex justify-center items-center">
                <div className="font-bold lg:text-3xl ">
                    Selamat Datang Di <span className="italic">AnimeCek</span> Website!
                </div>
            </nav>
                <div className="mt-6 p-5 bg-[#1E1F25] rounded-2xl  border-[rgb(48,54,68)] border-[0.00625rem] lg:h-[74vh] ">
                    <div className="text-3xl font-semibold text-center p-1">
                        {
                        props.rute == 'home' ?(<>Popular Things</>):(<></>)
                        }
                    </div>
                    
                    <div className="sm:block flex justify-center overflow-auto lg:h-[60vh] scroll-dark">
                        

                        {
                            popularResult?.length > 0 & props.rute == 'home'
                            ?
                            (
                                <div>
                                    {
                                    popularResult.map((animes) => (
                                        <AnimePopular res={animes}/>
                                    ) )
                                    }
                                </div>
                            ) : recomResult?.length > 0 & props.rute == 'recom' ?
                            (
                                
                                <div className="grid md:grid-cols-4 ">
                                    {
                                    recomResult.map((recom) => (
                                        <RecommendCard res={recom}/>
                                    ))
                                    }
                                </div>
                            ) : (
                                <div className="flex justify-center items-center h-full">
                                    <h2>Loading...</h2>
                                </div>
                            )
                        }
                    </div>
            </div>
        </div>
    );
}


const MainBody = () =>{
    
    return (
            <Routes> 
                <Route exact path="/" element={<HomeBody rute="home"/>} />
                <Route path="/search" Component={AnimeList}/>
                <Route path="/recom" element={<HomeBody rute="recom"/>}/>
                <Route exact path="/search/character" Component={CharacterList}/>
                <Route exact path="/view" element={<ViewBody/>}/>
            </Routes>
    );
}

export default MainBody;